import {
  BOOKINGS_TO_VALIDATE_ENDPOINT,
  BOOKINGS_TO_VALIDATE_PAYMENT_METHODS_ENDPOINT,
  JOBS_CANCELLATION_REASON_ENDPOINT,
  JOBS_CANCELLATION_START_ENDPOINT,
} from "@config/endpoints";
import { ROUTES } from "@config/app.routing";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";
import { ICancelSubmitReason } from "@typings/jobs";
import { PAYMENT_METHODS } from "@typings/globals";

import { ASYNC_ACTION_TYPES } from "@services/FetchFacade";
import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";
import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";
import { generateReturnUrl } from "@services/ProvidePaymentUrls";

import { asyncActionCreator } from "@app/services/AsyncActionCreator";
import { IStore } from "@app/redux/reducers";

const action = new ReduxActionNameCreator("bookings to validate");

export const FETCH_JOBS = action.make("fetch jobs");
export const FETCH_PAYMENT_METHODS = action.make("fetch payment methods");
export const SET_PAYMENT_METHOD = action.make("set payment method");
export const SUBMIT_PAYMENT = action.make("submit payment");
export const CANCEL_START = action.make("cancellation start");
export const CANCEL_REASON = action.make("cancellation pass reason");

export const submitPayment =
  (id: string, method: PAYMENT_METHODS) =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const returnUrl = generateReturnUrl({
      originRoute: `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_BOOKINGS_TO_VALIDATE}`,
      targetRoute: `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_DASHBOARD_MY_CLEANINGS}`,
    });

    const action = await asyncActionCreator({
      url: BOOKINGS_TO_VALIDATE_PAYMENT_METHODS_ENDPOINT.replace("{uuid}", id),
      action: SUBMIT_PAYMENT,
      method: ASYNC_ACTION_TYPES.POST,
      body: {
        method,
        returnUrl,
      },
    });

    return dispatch(action);
  };

export const fetchJobs =
  () => async (dispatch: ThunkActionDispatch, store: () => IStore) => {
    const action = await asyncActionCreator({
      url: BOOKINGS_TO_VALIDATE_ENDPOINT,
      action: FETCH_JOBS,
    });

    return dispatch(action);
  };

export const fetchPaymentMethods =
  (uuid: string) =>
  async (dispatch: ThunkActionDispatch, store: () => IStore) => {
    const action = await asyncActionCreator({
      url: BOOKINGS_TO_VALIDATE_PAYMENT_METHODS_ENDPOINT.replace(
        "{uuid}",
        uuid,
      ),
      action: FETCH_PAYMENT_METHODS,
    });

    return dispatch(action);
  };

export const setPaymentMethod = (payload: PAYMENT_METHODS) => ({
  type: SET_PAYMENT_METHOD,
  payload,
});

export const cancelStart =
  (id: string, jobUuid: string) =>
  async (dispatch: ThunkActionDispatch, store: () => IStore) => {
    const action = await asyncActionCreator({
      url: JOBS_CANCELLATION_START_ENDPOINT.replace("{uuid}", jobUuid),
      action: CANCEL_START,
      method: ASYNC_ACTION_TYPES.POST,
      params: {
        id,
        jobUuid,
      },
    });

    return dispatch(action);
  };

export const cancelSubmitReason =
  ({ jobId, cancellationId, body }: ICancelSubmitReason) =>
  async (dispatch: ThunkActionDispatch, store: () => IStore) => {
    const action = await asyncActionCreator({
      url: JOBS_CANCELLATION_REASON_ENDPOINT.replace(
        "{cancellationRequestUuid}",
        cancellationId,
      ),
      action: CANCEL_REASON,
      method: ASYNC_ACTION_TYPES.POST,
      body,
      params: {
        id: jobId,
      },
    });

    return dispatch(action);
  };
